import { AfterViewInit, Component, HostListener, Input, QueryList, ViewChildren, ChangeDetectionStrategy } from '@angular/core'
import { FormControl } from '@angular/forms'
import { SelectOptionComponent } from '@app-domains/ui/components/select/option/select-option.component'
import { OptionConfig, OptionGroupConfig } from '@app-domains/ui/components/select/select.component.types'
import {
    SelectControlRegistryService,
} from '@app-domains/ui/services/select-control-registry/select-control-registry.service'
import { delay } from '@app-lib/common.lib'
import { Observable } from 'rxjs'

@Component({
    selector: 'app-select-options',
    templateUrl: './select-options.component.html',
    styleUrls: ['./select-options.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class SelectOptionsComponent<T = unknown> implements AfterViewInit {
    @ViewChildren(SelectOptionComponent)
    public options: QueryList<SelectOptionComponent<T>>

    @Input()
    public configs$: Observable<(OptionConfig | OptionGroupConfig)[]>

    @Input()
    public control: FormControl

    @Input()
    public isLarge: boolean = false

    constructor(
        private selectControlRegistry: SelectControlRegistryService<T>,
    ) {
    }

    public ngAfterViewInit() {
        this.selectControlRegistry.initialiseOptions(this.control, this.options)
    }

    public async valueUpdated($event: string) {
        await delay(0)
        this.control.setValue($event)
    }

    @HostListener('keydown', ['$event'])
    public forwardEventToKeyManager(event: KeyboardEvent) {
        event.preventDefault()

        if (event?.key === 'Enter') {
            this.selectControlRegistry.close()
        } else {
            this.selectControlRegistry.forwardEvent(event)
        }
    }
}
